export default "__VITE_ASSET__DG7xz2jN__"